var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33301 22.1667V8.80719C2.33301 7.12269 2.33301 6.28042 2.61688 5.61922C2.97082 4.79483 3.62783 4.13782 4.45222 3.78387C5.11343 3.5 5.9474 3.5 7.6402 3.5H8.21664C8.92256 3.5 9.59055 3.8196 10.0335 4.36927L12.1534 7M12.1534 7H18.6663C20.2998 7 21.1166 7 21.7405 7.31789C22.2893 7.59753 22.7354 8.04372 23.0151 8.59252C23.333 9.21643 23.333 10.0332 23.333 11.6667V12.8333M12.1534 7H8.16634",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.68403 18.1003L4.03218 17.2338C4.88835 15.1025 5.31644 14.037 6.20914 13.4353C7.10184 12.8335 8.25451 12.8335 10.5598 12.8335H19.9636C23.1001 12.8335 24.6684 12.8335 25.3656 13.8586C26.0627 14.8839 25.4803 16.3337 24.3153 19.2334L23.9672 20.0998C23.111 22.2311 22.6829 23.2966 21.7902 23.8984C20.8975 24.5002 19.7448 24.5002 17.4395 24.5002H8.03581C4.89922 24.5002 3.33092 24.5002 2.6338 23.475C1.93668 22.4497 2.51913 20.9999 3.68403 18.1003Z",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.cda7103206719cded03e97d8ecaa991b.svg";
export { ForwardRef as ReactComponent };